import { animation, textAnimation } from '@design-system/styles'
import styled from '@emotion/styled'
import { colors, elevation, typo } from '@mathflat/common/style'
import {
  무료체험_시나리오_스와이퍼,
  무료체험_시나리오_스와이퍼_슬라이드,
} from 'src/constant/ui/DOM'

const ribbonPadLeft = 15
const ribbonPadRight = 39
const bounceAmount = 10
const SCENARIO_MIN_Z_INDEX = 22

// zIndex가 의존적임
const zIndex = {
  overlay: SCENARIO_MIN_Z_INDEX,
  get swiper() {
    return this.overlay + 1
  },
  get folder() {
    return this.swiper + 1
  },
  get navigation() {
    return this.folder + 1
  },
  get ribbon() {
    return this.folder + 1
  },
}

const S = {
  ScenarioContainer: styled.div`
    position: absolute;
    left: 0;
    bottom: 0;

    display: flex;

    width: 100%;
    height: 168px;
    padding-bottom: 16px;

    &:before {
      z-index: ${zIndex.overlay};
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, ${colors.gray.$900} 100%);
      opacity: 0.1;
    }
    .folder {
      position: absolute;
      padding-left: 49px;
      z-index: ${zIndex.folder};
    }
    .scenario-swiper-container {
      display: flex;
      padding-top: 17px;
      padding-left: 55px;
      width: 100%;
      height: 100%;
      z-index: ${zIndex.swiper};

      #${무료체험_시나리오_스와이퍼} {
        display: flex;
        > div:first-of-type {
          display: flex;
          padding-left: 274px;
        }
      }

      .${무료체험_시나리오_스와이퍼_슬라이드} {
        margin-left: 6px;
      }
    }

    .navigation-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;

      width: 40px;
      height: 40px;

      border: 1px solid ${colors.gray.$300};
      border-radius: var(--Radius-Circle);
      ${elevation.$03};
      background-color: #ffffff;
      z-index: ${zIndex.navigation};
      &.navigation-prev {
        left: 50px;
      }
      &.navigation-next {
        right: 59px;
      }
    }
    //TODO: 디자인시스템의 Icon Button으로 교체되어야 함.
    /* .swiper-button-prev {
      width: 40px;
      height: 40px;
      background: #ffffff;
      border: 1px solid ${colors.gray.$300};
      border-radius: var(--Radius-100);
      ${elevation.$03};
    } */
  `,
  RibbonButton: styled.button`
    position: absolute;
    z-index: ${zIndex.ribbon};
    left: ${-bounceAmount}px;
    bottom: 43px;
    background-color: ${colors.blue.$100};

    clip-path: polygon(100% 0%, calc(100% - 12px) 50%, 100% 100%, 0 100%, 0% 50%, 0 0);
    border: 1px solid ${colors.blue.$100};
    ${elevation.$03};

    ${animation.horizontalBounce(`calc(-100% + ${ribbonPadRight}px)`, -bounceAmount, 'right')};

    .ribbon-button-inner {
      position: relative;
      padding: 16px ${ribbonPadLeft}px;
      padding-left: ${ribbonPadLeft + bounceAmount}px;
      padding-right: 30px;
      background: linear-gradient(90deg, var(--Colors-Sky-400) 4.26%, #6069ff 96.39%);
      clip-path: polygon(100% 0%, calc(100% - 12px) 50%, 100% 100%, 0 100%, 0% 50%, 0 0);

      color: #ffffff;
      ${typo.caption01};
      font-weight: 700;
    }
    &.unfolded .ribbon-button-inner-text {
      ${textAnimation.angleAndWipe('#ffffff')};
    }
    &.folded {
      span {
        color: transparent;
      }
      ${animation.horizontalBounce(
        -bounceAmount,
        `calc(-100% + ${ribbonPadRight + bounceAmount}px)`,
        'left',
      )}
    }
    .ribbon-button-inner-text {
      display: flex !important;
      align-items: center;
      color: #fff;
    }
    .chevron-left-icon {
      position: absolute;
      top: 25%;
      right: 15px;
    }
  `,
}

export default S
